import { PaymentDependenciesFactory } from "./dependencies.factory";

export const paymentEpicsDependencies = {
    paymentService: PaymentDependenciesFactory.getPaymentService()
}
